import { createSubscription, manageSubscritpion } from "network/apis/stripe";
import { useQuery } from "react-query";
import { QUERIES, StripeFailCode, StripeSuccessCode } from "utils/constants";

export const useCreateSubscription = (priceId: string, enabled: boolean) => {
  return useQuery(
    [QUERIES.LOAD_CREATE_SUBSCRITPION, priceId],
    () =>
      createSubscription({
        priceId: priceId,
        successURL:
          window.location.href +
          (window.location.search ? "&" : "?") +
          "status=" +
          StripeSuccessCode,
        cancelURL:
          window.location.href +
          (window.location.search ? "&" : "?") +
          "status=" +
          StripeFailCode
      }),
    {
      enabled: enabled
    }
  );
};

export const useManageSubscription = (enabled: boolean) => {
  return useQuery(
    [QUERIES.LOAD_MANAGE_SUBSCRIPTION],
    () =>
      manageSubscritpion({
        returnURL: window.location.href
      }),
    {
      enabled: enabled
    }
  );
};
